var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNoDataComponent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 168,
    viewBox: "0 0 220 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 88,
    r: 80,
    fill: "#E4E4E4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 26,
    cy: 28,
    r: 8,
    fill: "#E0E0E1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 198,
    cy: 134,
    r: 6,
    fill: "#E0E0E1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 25,
    cy: 146,
    r: 10,
    fill: "#E0E0E1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 210,
    cy: 54,
    r: 10,
    fill: "#E0E0E1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 191,
    cy: 19,
    r: 7,
    fill: "#E0E0E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3775_74340)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M162.781 33H60.2182C58.8345 33.0008 57.5077 33.5006 56.5293 34.3898C55.5509 35.2789 55.0009 36.4846 55 37.7421V123.258C55.0009 124.515 55.5509 125.721 56.5293 126.61C57.5077 127.499 58.8345 127.999 60.2182 128H162.781C164.165 127.999 165.492 127.5 166.47 126.61C167.449 125.721 167.999 124.515 168 123.258V37.7421C167.999 36.4845 167.449 35.2788 166.47 34.3896C165.492 33.5005 164.165 33.0006 162.781 33Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.141 95.5642H67.4069C64.5356 95.5642 62.2077 93.2363 62.2077 90.3651V7.52366C62.2077 4.6524 64.5356 2.32446 67.4069 2.32446H156.141C159.012 2.32446 161.34 4.6524 161.34 7.52366V90.3651C161.34 93.2363 159.012 95.5642 156.141 95.5642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8538 92.0106V9.16975C63.8538 6.29849 66.1817 3.97055 69.053 3.97055H157.787C158.801 3.97055 159.744 4.2653 160.543 4.76729C159.624 3.30159 157.998 2.32446 156.141 2.32446H67.4069C64.5356 2.32446 62.2077 4.6524 62.2077 7.52366V90.365C62.2077 92.2232 63.1848 93.8484 64.6505 94.768C64.1485 93.9681 63.8538 93.0253 63.8538 92.0111V92.0106Z",
    fill: "url(#paint0_linear_3775_74340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.223 19.8275H78.3253V23.6399H145.223V19.8275ZM145.223 34.3846H78.3253V38.197H145.223V34.3846ZM145.223 48.9449H78.3253V52.7574H145.223V48.9449ZM145.223 63.5021H78.3253V67.315H145.223V63.5021Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.298 51.1967L103.108 68.0076H86.298V51.1967Z",
    fill: "url(#paint1_linear_3775_74340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.948 72.8929L168.699 124.204C168.337 126.769 166.142 128.676 163.551 128.676H59.9957C57.4053 128.676 55.2099 126.769 54.8475 124.204L45.0521 54.8702C44.6102 51.7401 47.0391 48.9435 50.2003 48.9435H82.1804C84.7708 48.9435 86.9662 50.85 87.3286 53.4147L88.6123 62.4945C88.9747 65.0597 91.17 66.9662 93.7604 66.9662H170.801C173.961 66.9662 176.39 69.7628 175.948 72.8929H175.948Z",
    fill: "url(#paint2_linear_3775_74340)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.266 105.789H73.2822C72.8603 105.789 72.4528 105.635 72.1363 105.356C71.8197 105.077 71.6158 104.692 71.5626 104.273L70.5994 96.6474C70.5688 96.4034 70.5904 96.1557 70.6629 95.9208C70.7353 95.6858 70.8568 95.4689 71.0195 95.2845C71.1821 95.1001 71.382 94.9524 71.6061 94.8512C71.8302 94.75 72.0732 94.6975 72.3191 94.6974H151.229C151.475 94.6975 151.718 94.75 151.942 94.8512C152.166 94.9524 152.366 95.1001 152.528 95.2845C152.691 95.4689 152.813 95.6858 152.885 95.9208C152.957 96.1557 152.979 96.4034 152.948 96.6474L151.985 104.273C151.932 104.692 151.728 105.077 151.412 105.356C151.095 105.635 150.688 105.789 150.266 105.789Z",
    fill: "#7A7A7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3775_74340",
    x1: 114.822,
    y1: 51.9874,
    x2: 49.0701,
    y2: -13.7655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3775_74340",
    x1: 97.4046,
    y1: 70.7049,
    x2: 77.0851,
    y2: 50.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3775_74340",
    x1: 110.5,
    y1: 48.9435,
    x2: 110.5,
    y2: 128.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3775_74340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131,
    height: 131,
    fill: "white",
    transform: "translate(45)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNoDataComponent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-no-data-component.b8681798b54b8c118bed8308d3662cc5.svg";